import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import axios from 'axios';
import Pusher from 'pusher-js';

import Cookies from 'js-cookie';
const jwtCookie = Cookies.get(
  `${process.env.REACT_APP_COOKIE_CONSTANT}`
);

import MainHeader from '../MainHeader/MainHeader';
import HeaderBanner from 'components/UI/HeaderBanner/HeaderBanner';
import FooterBanner from 'components/UI/FooterBanner/FooterBanner';
import Loading from 'components/UI/Loading/Loading';
import classes from './Layout.module.css';

const Layout = props => {
  const dataAcademy = useSelector(state => state.academyInfo);
  const [showPage, setShowPage] = useState(false);
  const [channel, setChannel] = useState('false');
  useEffect(() => {
    if (dataAcademy !== undefined) {
      if (
        dataAcademy.data.idAcademy === 1816 ||
        dataAcademy.data.idAcademy === 58 ||
        dataAcademy.data.idAcademy === 1153
      ) {
        if (jwtCookie) {
          axios
            .post('https://saml.mayahii.com/validate', {
              jwt: jwtCookie
            })
            .then(response => {
              if (!response.data.jwtStatus) {
                document.cookie =
                  'mayahiijwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.mayahii.com;';
                window.location.href = `https://saml.mayahii.com/connect?connection=TEC&returnUrl=${encodeURIComponent(
                  `${process.env.REACT_APP_API_PATH_MAYAHII}/${dataAcademy.data.shortName}`
                )}`;
              } else {
                setChannel(response.data.channel);
                setShowPage(true);
              }
            });
        } else {
          window.location.href = `https://saml.mayahii.com/connect?connection=TEC&returnUrl=${encodeURIComponent(
            `${process.env.REACT_APP_API_PATH_MAYAHII}/${dataAcademy.data.shortName}`
          )}`;
        }
      } else {
        setShowPage(true);
      }
    }
  }, [dataAcademy.data]);

  useEffect(() => {
    if (
      (dataAcademy.data.idAcademy === 1816 ||
        dataAcademy.data.idAcademy === 58 ||
        dataAcademy.data.idAcademy === 1153) &&
      channel
    ) {
      let pusher = new Pusher('8077d5a80229a942c1b8', {
        cluster: 'mt1'
      });
      let channel = pusher.subscribe(this.state.channel);
      channel.bind('logout', function (data) {
        console.log(JSON.stringify(data));
        document.cookie =
          'mayahiijwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.mayahii.com;';
        window.location.href = `https://saml.mayahii.com/connect?connection=TEC&returnUrl=${encodeURIComponent(
          `${process.env.REACT_APP_API_PATH_MAYAHII}/${dataAcademy.data.shortName}`
        )}`;
      });
    }
  }, [channel]);

  return (
    <>
      {!showPage ? (
        <Loading />
      ) : (
        <>
          <MainHeader />
          <HeaderBanner />
          <main className={classes.mainContainer}>
            {props.children}
          </main>
          <FooterBanner />
        </>
      )}
    </>
  );
};

Layout.propTypes = {
  // eslint-disable-next-line react/require-default-props
  children: PropTypes.data
};

export default Layout;
